import { render, staticRenderFns } from "./EditTableLoader.vue?vue&type=template&id=e13cf37a"
import script from "./EditTableLoader.vue?vue&type=script&lang=ts"
export * from "./EditTableLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports